module.exports = __webpack_public_path__ + "static/img/step_2-button-selected.fff05e6f.png";